// src/App.js
import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ImageCard from './ImageCard';
import WordCard from './WordCard';
import './Matching.css';
import appleImage from './images/apple.jpg';
import bananaImage from './images/banana.jpg';
import kiwiImage from './images/Kiwi.jpg';

const images = [
  { id: 1, src: appleImage, name: 'Apple' },
  { id: 2, src: bananaImage, name: 'Banana' },
  { id: 3, src: kiwiImage, name: 'Kiwi' },
  // Add more images as needed
];

const Matching = () => {
  const [matchedWords, setMatchedWords] = useState([]);

  const handleDropWord = (imageId, item) => {
    const image = images.find((img) => img.id === imageId);
    if (image.name.toLowerCase() === item.word.toLowerCase()) {
      setMatchedWords([...matchedWords, item.word]);
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="appMatching">
        <h1>Match Words with Images</h1>
        <h2>Drage the word into correct image</h2>
        <div className="images-container">
          {images.map((image) => (
            <ImageCard
              key={image.id}
              id={image.id}
              src={image.src}
              name={image.name}
              onDropWord={handleDropWord}
            />
          ))}
        </div>
        <div className="words-container">
          {['kiwi', 'apple', 'banana'].map((word) => (
            <WordCard key={word} word={word} />
          ))}
        </div>
        {matchedWords.length === images.length && (
          <div className="congratulations">
            <h2>Congratulations! You've matched all the words!</h2>
          </div>
        )}

{matchedWords.length !== images.length && (
          <div className="congratulations">
            <h2>Match the words Correctly!</h2>
          </div>
        )}
        
      </div>
    </DndProvider>
  );
};

export default Matching;
